export default "__VITE_ASSET__BKOmQJy4__"